import { render, staticRenderFns } from "./bottom-navbar.vue?vue&type=template&id=4de27b40&scoped=true&"
import script from "./bottom-navbar.vue?vue&type=script&lang=js&"
export * from "./bottom-navbar.vue?vue&type=script&lang=js&"
import style0 from "./bottom-navbar.vue?vue&type=style&index=0&id=4de27b40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de27b40",
  null
  
)

export default component.exports